var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 112,
    viewBox: "0 0 184 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 112
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 112,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.578 39.6856C103.477 40.8434 104.565 41.8457 105.724 42.5715C107.331 43.6082 109.025 44.1442 110.77 44.1442C117.233 44.1442 122.261 36.8173 122.261 30.5266C122.261 24.1675 117.111 19 110.77 19C104.411 19 99.2432 24.1668 99.2432 30.5266C99.2432 33.5854 100.453 36.9551 102.474 39.5646C102.492 39.5822 102.543 39.6336 102.579 39.6856L102.578 39.6856Z",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9961 61.1369C92.0546 62.0126 91.0673 62.7811 90.0311 63.411C87.4186 65.1035 84.5484 65.988 81.5817 65.988C77.1915 65.988 73.2631 64.085 70.1202 61.1559C57.4441 65.8363 48.3691 78.0015 48.3691 92.2717C48.3691 93.2395 49.1464 93.9999 50.0974 93.9999H113.051H113.086C114.053 93.9999 114.814 93.2396 114.814 92.2717C114.814 92.1508 114.814 92.0298 114.779 91.9264C114.631 77.7722 105.587 65.7625 92.9962 61.1362L92.9961 61.1369Z",
    className: "primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.748 42.8755C118.143 45.6994 114.689 47.601 110.772 47.601C108.367 47.601 106.038 46.8852 103.853 45.4762C102.762 44.7923 101.708 43.9003 100.765 42.8768C100.695 42.9087 100.629 42.9501 100.559 42.9833C100.577 43.33 100.611 43.6722 100.611 44.0239C100.611 48.8266 98.7313 54.1476 95.5772 58.2958C95.5433 58.3466 95.5114 58.3761 95.4775 58.4224C100.028 60.2967 104.078 63.0365 107.452 66.42L133.046 66.4194C133.996 66.4194 134.774 65.6415 134.774 64.6912C134.774 55.0188 129.014 46.6773 120.747 42.8759L120.748 42.8755Z",
    className: "secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5828 62.5327C83.8813 62.5327 86.1278 61.8244 88.2358 60.4592C89.8255 59.4914 91.2946 58.1436 92.5904 56.5021C92.6424 56.45 92.6938 56.398 92.7289 56.3291C95.4938 52.7518 97.153 48.1553 97.153 44.0252C97.153 35.4366 90.1714 28.4551 81.5828 28.4551C72.9942 28.4551 66.0127 35.4366 66.0127 44.0252C66.0127 52.5788 72.8212 62.5333 81.5828 62.5333L81.5828 62.5327Z",
    className: "primary-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInsights);
export default __webpack_public_path__ + "static/media/client-insights.b742e6b588538add4f838f77ec03efee.svg";
export { ForwardRef as ReactComponent };